import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface EditProductCategoryPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;
  onUpdate: (categoryData: { id: number; name: string }) => void;
  selectedCategory: { id: number; name: string } | null;
}

const EditProductCategoryPopup: React.FC<EditProductCategoryPopupProps> = ({
  popupOpen,
  setPopupOpen,
  onUpdate,
  selectedCategory,
}) => {
  // Esquema de validación con Yup
  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, 'El nombre debe tener al menos 2 caracteres')
      .required('El nombre de la categoría de producto es obligatorio'),
  });

  // Inicialización de Formik
  const formik = useFormik({
    initialValues: {
      id: selectedCategory?.id || 0,
      name: selectedCategory?.name || '',
    },
    validationSchema,
    onSubmit: (values) => {
      onUpdate(values);
      setPopupOpen(false);
    },
    enableReinitialize: true, // Permite actualizar los valores cuando cambia `selectedCategory`
  });

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Editar Categoría de Producto"
      maxWidth="max-w-md" // o el tamaño que necesites
    >
      <form onSubmit={formik.handleSubmit} className="mt-4">
        {/* Nombre de la Categoría de Producto */}
        <InputField
          label="Nombre"
          name="name"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name && formik.errors.name
              ? formik.errors.name
              : undefined
          }
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Cambios
        </button>
      </form>
    </FormModal>
  );
};

export default EditProductCategoryPopup;
